import { SettingsButton } from 'src/components';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
`;

export const TableSettingContainer = styled.div`
  display: flex;
`;

export const SearchbarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
`;

export const BenefitsColumnsSettingsButton = styled(SettingsButton)``;
